import { Component, ViewChild, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnChanges {
  @Input() videoUrl = '';
  @Input() videoTitle = '';
  @Input() controls = true;
  @Input() autoplay = false;
  @Input() loop = false;
  @Input() muted = false;
  @Input() preload: 'auto' | 'metadata' | 'none' = 'auto';
  @Input() poster = '';
  @Input() width = '100%';
  @Input() height = 'auto';

  @ViewChild('vimePlayer', { static: false }) vimePlayer: ElementRef | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoUrl'] && this.videoUrl) {
      setTimeout(() => this.reloadPlayer(), 50);
    }
  }

  getVideoType(): string {
    if (!this.videoUrl) return 'video/mp4';

    if (this.videoUrl.endsWith('.mp4')) return 'video/mp4';
    if (this.videoUrl.endsWith('.webm')) return 'video/webm';
    if (this.videoUrl.endsWith('.ogg')) return 'video/ogg';
    if (this.videoUrl.endsWith('.mov')) return 'video/quicktime';
    if (this.videoUrl.endsWith('.avi')) return 'video/x-msvideo';
    return 'video/mp4';
  }

  onPlayerReady(): void {
    console.log('Vime player is ready', this.videoTitle || this.videoUrl);
  }

  onError(event: any): void {
    console.error('Video player error:', event);
  }

  async play(): Promise<void> {
    const player = this.vimePlayer?.nativeElement;
    if (player) {
      try {
        await player.play();
      } catch (err) {
        console.error('Error playing video:', err);
      }
    }
  }

  async pause(): Promise<void> {
    const player = this.vimePlayer?.nativeElement;
    if (player) {
      try {
        await player.pause();
      } catch (err) {
        console.error('Error pausing video:', err);
      }
    }
  }

  private async reloadPlayer(): Promise<void> {
    const player: any = this.vimePlayer?.nativeElement;
    if (!player) return;

    try {
      if (typeof player.pause === 'function') {
        await player.pause();
      }
    } catch (err) {
      console.error('reloadPlayer: pause() failed', err);
    }

    try {
      if (typeof player.load === 'function') {
        player.load();
      }
    } catch (err) {
      console.error('reloadPlayer: load() failed', err);
    }

    try {
      if (this.autoplay) {
        await player.play();
      }
    } catch (err) {
      console.debug('reloadPlayer: play() blocked or failed', err);
    }
  }

  setVolume(volume: number): void {
    const player = this.vimePlayer?.nativeElement;
    if (player && volume >= 0 && volume <= 100) {
      player.volume = volume;
    }
  }

  getCurrentTime(): number {
    const player = this.vimePlayer?.nativeElement;
    return player?.currentTime || 0;
  }

  getDuration(): number {
    const player = this.vimePlayer?.nativeElement;
    return player?.duration || 0;
  }

  seekTo(time: number): void {
    const player = this.vimePlayer?.nativeElement;
    if (player) {
      player.currentTime = time;
    }
  }
}
